import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Nunito Sans auto-hospedada (substituta livre da Omnes, fonte do manual).
// Arquivo variável único: cobre 400/600/700/800 sem múltiplos downloads e
// sem depender do Google Fonts em runtime.
import '@fontsource-variable/nunito-sans';

import App from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
